import { Datagrid, DateField, Filter, List, TextField, TextInput } from 'react-admin';

import React from 'react';

const ListFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Series" source="series||$contL" alwaysOn />
    <TextInput label="User ID" source="userId||$eq" alwaysOn />
  </Filter>
);

export const SeriesOptOutList = (props: any) => (
  <List {...props} filters={<ListFilter />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="series" />
      <TextField source="userId" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
);
